import { DatePicker, Table, TableColumn, Select, Option, Checkbox, Popover } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import { Pagination as LPagination } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
import ConfirmDialog from '@/components/shared/confirm-dialog/confirm-dialog.vue';
import {
    buildMembershipTypeRemovalWarning,
    buildMembershipTypeStatusChangeWarning
} from '@/components/user/dashboard/pages/clubs/register-club/constants/club-registration-constants.js';
const svc = new ResourceSvc();

export default {
    name: 'AdminClubMembershipTypeTab',
    components: { LPagination, [Checkbox.name]: Checkbox, [Select.name]: Select, [Option.name]: Option, [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, LSwitch, [Popover.name]: Popover, 'confirm-dialog': ConfirmDialog },
    data() {
        return {
            errorMessage: '',
            isViewReportMode: false,
            isLoading: true,
            isEditCTMMode: false,
            isViewCTMClubMode: false,
            isJoinToClubMode: false,
            isJoinToClubAddMode: false,
            activeYear: null,

            isRemovalWarningVisible: false,
            removalWarning: null,
            removalConfirmText: 'Remove and continue',
            pendingRemovalAction: null,
            pendingRemovalLookupId: null,

            pagination: { perPageOptions: [10, 25, 50, 100], currentPage: 1, perPage: 10, total: 0, from: 0, to: 0 },
            params: { seachQuery: '', onlyWithConnectedClubs: null, minAge: null, maxAge: null, forAge: null, status },
            tableData: [],
            //{
            //    id: 0, name: '', status: 0, statusString: '', maxAge: 0, maxAgeString: '', connectedClubsCount: 0,
            //    allowJuniorAccounts: 0, allowJuniorAccountsString: '', allowAdultAccounts: 0, allowAdultAccountsString: '', minAge: 0, minAgeString: '',
            //}],
            savedParams: null,

            currentCTM: {
                id: 0, name: '', status: 0, statusString: '', connectedClubsCount: 0,
                allowJuniorAccounts: 0, allowJuniorAccountsString: '', allowAdultAccounts: 0, allowAdultAccountsString: '',
                minAge: 0, minAgeString: '', maxAge: 0, maxAgeString: '',
                isAllowedJuniorAccounts: false, isAllowedAdultAccounts: false, isAllowedMinAge: false, isAllowedMaxAge: false
            },

            clubsPagination: { perPageOptions: [10, 25, 50, 100], currentPage: 1, perPage: 10, total: 0, from: 0, to: 0 },
            clubsParams: { searchQuery: '', year: null, take: 5, skip: 0, clubMembershipTypeId: 0 },
            clubsTableData: [],//{ id: 0, clubName: '', clubId: 0, clubMembershipTypeId: 0, price: 0, clubYear: 0 }],
            clubsSavedParams: null,
            allYears: [],
            allJoinClubs: [],
            isNeedChangeYears: true,

            currentJoinToClubItem: {
                id: 0,
                clubId: null,
                clubName: 'new club',
                price: 0,
                clubMembershipTypeId: 0
            },
            report: [{
                clubId : 0,
                clubName: '',
                connectedCTMs: [{
                    name: '',
                    price: 0
                }]
            }]
        };
    },
    methods: {
        //get report
        closeReport() {
            this.isViewReportMode = false;
        },
        getReport() {
            var self = this;
            self.isLoading = true;
            svc.getClubMembershipTypesReport().then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (allData && typeof allData != "string" && allData.isSuccess != false) {
                    self.report = allData;
                    self.isViewReportMode = true;
                }
                else {
                    self.$showError("Error occured: " + allData.message);
                }
            }, resp => { self.isLoading = false; self.$showError("Something went wrong. Now, we can't load report."); });
        },
        //get ctm
        getFrom(total) {
            if (this.pagination.total == 0) return 0;
            return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        getTo() {
            if (this.pagination.total == 0) return 0;
            if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) return this.pagination.total;
            return (this.pagination.currentPage) * this.pagination.perPage;
        },
        getParams() {
            var data = {
                take: this.pagination.perPage,
                skip: (this.pagination.currentPage - 1) * this.pagination.perPage,
                search: this.params.searchQuery,
                minAge: this.params.minAge,
                maxAge: this.params.maxAge,
                forAge: this.params.forAge,
                status: this.params.status,
                onlyWithConnectedClubs: this.params.onlyWithConnectedClubs
            }
            return data;
        },
        queriedData() {
            var self = this;
            var params = this.getParams();
            if (JSON.stringify(params) != this.savedParams) {
                self.savedParams = JSON.stringify(params);
                return self.loadData(params);
            }
            return self.tableData;
        },
        loadData(params) {
            var self = this;
            self.isLoading = true;
            svc.getClubMebershipTypes(params).then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (allData == null || !allData.isSuccess) {
                    self.tableData = [];

                    if (allData.currentUserId == 0) {
                        self.$showError("You are not authorized!");
                        setTimeout(function () {
                            self.$router.push({ path: '"/"' })
                        }, 2000)
                    }
                    return;
                } else {
                    self.tableData = allData.clubMemebershipTypesModels;
                    self.pagination.total = allData.total;

                    if (!self.activeYear) {
                        if (allData.activeYear) {
                            self.activeYear = allData.activeYear;
                        }
                        else {
                            self.activeYear = 'current';
                        }
                    }
                }
                self.errorMessage = allData.message;

                self.pagination.from = self.getFrom();
                self.pagination.to = self.getTo();
            }, resp => { return []; });
        },

        //edit CTM
        isAllowedSaveCTM() {
            var error = '';
            if (this.currentCTM.name.length < 3 || this.currentCTM.name.length > 100) {
                error = 'Club membership name should be from 3 to 100 symbols';
            }

            if (this.currentCTM.isAllowedAdultAccounts) {
                if (this.currentCTM.allowAdultAccounts < 1 || this.currentCTM.allowAdultAccounts > 100) {
                    error = 'Adult account count value should be from 1 to 100';
                }
            }
            else {
                this.currentCTM.allowAdultAccounts = 0;
            }

            if (this.currentCTM.isAllowedJuniorAccounts) {
                if (this.currentCTM.allowJuniorAccounts < 1 || this.currentCTM.allowJuniorAccounts > 100) {
                    error = 'Junior account count value should be from 1 to 100';
                }
            }
            else {
                this.currentCTM.allowJuniorAccounts = 0;
            }

            if (this.currentCTM.isAllowedMinAge && this.currentCTM.isAllowedMaxAge && this.currentCTM.minAge > this.currentCTM.maxAge) {
                error = 'Max age can not be less then min age';
            }

            if (this.currentCTM.isAllowedMinAge) {
                if (this.currentCTM.minAge < 1 || this.currentCTM.minAge > 100) {
                    error = 'Min age value should be from 1 to 100';
                }
            }
            else {
                this.currentCTM.minAge = 0;
            }

            if (this.currentCTM.isAllowedMaxAge) {
                if (this.currentCTM.maxAge < 1 || this.currentCTM.maxAge > 100) {
                    error = 'Max age value should be from 1 to 100';
                }
            }
            else {
                this.currentCTM.maxAge = 0;
            }

            if (error) {
                this.$showError(error);
                return false;
            }

            return true;
        },
        saveCTM(acknowledgedRemovals = false) {
            if (!this.isAllowedSaveCTM()) {
                return;
            }

            var self = this;
            svc.saveClubMembershipType(self.currentCTM, acknowledgedRemovals === true).then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (!allData || !allData.isSuccess) {
                    self.$showError(allData && allData.message);
                    return;
                } else {
                    var result = allData.outputData;
                    if (result && result.status === 'ConfirmationRequired') {
                        self.confirmMembershipTypeStatusChange(result);
                        return;
                    }

                    self.changeCTMList();
                    self.$showSuccess();
                    if (!self.currentCTM.id) {
                        self.loadData();
                        self.switchIsEditCTMMode();
                    }
                }
            }, resp => { self.$showError(resp.body); });
        },
        changeCTMList() {
            var self = this;
            self.loadData(self.getParams());
        },
        getCTM(id) {
            var self = this;
            var dataArray = this.tableData.filter(ctm => {
                return ctm.id == id;
            });
            if (!dataArray || dataArray.length != 1) {
                this.$showError("Can't retrieve correct club membership");
                return;
            }
            this.currentCTM = dataArray[0];
            this.isNeedChangeYears = true;
        },
        editCTM(id) {
            if (id) {
                this.getCTM(id);
            }
            else {
                this.currentCTM = {
                    id: 0, name: '', status: 1, statusString: '', connectedClubsCount: 0,
                    allowJuniorAccounts: 0, allowJuniorAccountsString: '', allowAdultAccounts: 0, allowAdultAccountsString: '',
                    minAge: 0, minAgeString: '', maxAge: 0, maxAgeString: '',
                    isAllowedJuniorAccounts: false, isAllowedAdultAccounts: false, isAllowedMinAge: false, isAllowedMaxAge: false
                };
            }
            
            this.switchIsEditCTMMode();
        },
        switchIsEditCTMMode() {
            if (!this.isEditCTMMode) {
                this.isViewCTMClubMode = false;
                this.isJoinToClubMode = false;
            }
            this.isEditCTMMode = !this.isEditCTMMode;
        },
        //remove
        removeForClub(lookupId, acknowledgedRemovals = false) {
            var self = this;
            svc.deleteClubMembershipTypeFromClubAsync(lookupId, acknowledgedRemovals === true).then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (!allData || !allData.isSuccess) {
                    self.$showError(allData && allData.message);
                    return;
                }

                var result = allData.outputData;
                if (result && result.status === 'ConfirmationRequired') {
                    self.confirmMembershipTypeRemoval(lookupId, result.removedMembershipTypes);
                    return;
                }

                self.$showSuccess();
                self.loadConnectedClubs();
            }, resp => { return []; });

        },

        confirmMembershipTypeRemoval(lookupId, removedMembershipTypes) {
            this.pendingRemovalAction = 'lookup';
            this.pendingRemovalLookupId = lookupId;
            this.removalWarning = buildMembershipTypeRemovalWarning(removedMembershipTypes);
            this.removalConfirmText = 'Remove and continue';
            this.isRemovalWarningVisible = true;
        },

        confirmMembershipTypeStatusChange(result) {
            this.pendingRemovalAction = 'status';
            this.removalWarning = buildMembershipTypeStatusChangeWarning(result);
            this.removalConfirmText = 'Save and continue';
            this.isRemovalWarningVisible = true;
        },

        cancelMembershipTypeRemoval() {
            this.isRemovalWarningVisible = false;
            this.removalWarning = null;
            this.pendingRemovalAction = null;
            this.pendingRemovalLookupId = null;
        },

        acceptMembershipTypeRemoval() {
            var action = this.pendingRemovalAction;
            var lookupId = this.pendingRemovalLookupId;
            this.cancelMembershipTypeRemoval();

            if (action === 'status') {
                this.saveCTM(true);
                return;
            }

            this.removeForClub(lookupId, true);
        },

        //get ctm clubs
        switchIsViewCTMClubMode(id) {
            if (!this.isViewCTMClubMode) {
                if (id) {
                    this.getCTM(id);
                }
                this.clubsParams.clubMembershipTypeId = this.currentCTM.id;
                this.isEditCTMMode = false;
                this.isJoinToClubMode = false;
            }
            this.isViewCTMClubMode = !this.isViewCTMClubMode;
        },
        getClubsParams() {
            return {
                clubMembershipTypeId: this.clubsParams.clubMembershipTypeId,
                searchQuery: this.clubsParams.searchQuery,
                take: this.clubsPagination.perPage,
                skip: (this.clubsPagination.currentPage - 1) * this.clubsPagination.perPage,
                year: this.clubsParams.year,
                status: this.clubsParams.status
            };
        },
        loadConnectedClubs(params) {
            var self = this;
            if (!params) {
                params = self.getClubsParams();
            }

            svc.getClubMebershipTypeClubs(params).then(function (resp) {
                self.isLoading = false;
                var allData = resp.body;
                if (allData == null || !allData.isSuccess) {
                    self.clubsTableData = [];
                    return;
                } else {
                    self.clubsTableData = allData.connectedClubs;
                    self.clubsPagination.total = allData.total;
                    if (!self.allYears || self.allYears.length < 1 || self.isNeedChangeYears) {
                        self.allYears = allData.allYears;
                        self.isNeedChangeYears = false;
                    }
                }
                self.errorMessage = allData.message;
                self.clubsPagination.from = self.getClubsFrom();
                self.clubsPagination.to = self.getClubsTo();
            }, resp => { return []; });
        },
        clubsQueriedData() {
            var self = this;
            var params = this.getClubsParams();
            if (JSON.stringify(params) != self.clubsSavedParams) {
                self.clubsSavedParams = JSON.stringify(params);
                return self.loadConnectedClubs(params);
            }
            return self.clubsTableData;
        },
        getClubsFrom(total) {
            if (this.clubsPagination.total == 0) return 0;
            return (this.clubsPagination.currentPage - 1) * this.clubsPagination.perPage + 1;
        },
        getClubsTo() {
            if (this.clubsPagination.total == 0) return 0;
            if ((this.clubsPagination.currentPage) * this.clubsPagination.perPage > this.clubsPagination.total) return this.clubsPagination.total;
            return (this.clubsPagination.currentPage) * this.clubsPagination.perPage;
        },

        //edit club for ctm
        switchIsJoinToClubMode(id) {
            if (!this.isJoinToClubMode) {
                if (id) {
                    var dataArray = this.clubsTableData.filter(item => {
                        return item.id == id;
                    });

                    if (!dataArray || dataArray.length != 1) {
                        this.$showError("Can't retrieve club item to edit. Please reload page");
                        return;
                    }
                    this.currentJoinToClubItem = dataArray[0];
                    this.isJoinToClubAddMode = false;
                }
                else {
                    this.currentJoinToClubItem = { id: 0, clubId: null, clubName: 'New Club', price: 0, clubMembershipTypeId: this.currentCTM.id }
                    this.isJoinToClubAddMode = true;
                }
                this.isEditCTMMode = false;
                this.isViewCTMClubMode = false;

                this.loadActiveClubsForCTM();
            }


            this.isJoinToClubMode = !this.isJoinToClubMode;
        },
        loadActiveClubsForCTM() {
            var self = this;
            svc.getAllClubsForCurrentActiveYear(this.currentJoinToClubItem.clubMembershipTypeId)
                .then(function (resp) {
                    var allData = resp.body;
                    if (!allData) {
                        self.allJoinClubs = [];
                        return;
                    } else {
                        allData[0].id = null;
                        self.allJoinClubs = allData;
                    }
                    self.errorMessage = allData.message;
                }, resp => { });
        },
        changeJoinClub() {
            if (this.currentJoinToClubItem.clubId) {
                var dataArray = this.allJoinClubs.filter(item => {
                    return item.id == this.currentJoinToClubItem.clubId;
                });

                if (!dataArray || dataArray.length != 1) {
                    this.$showError("Can't retrieve club item to edit. Please reload page");
                    return;
                }
                var item = dataArray[0];
                this.currentJoinToClubItem.clubId = item.id;
                this.currentJoinToClubItem.clubName = item.name;
            }
            else {
                this.currentJoinToClubItem.clubName = '';
                this.currentJoinToClubItem.clubId = null;
            }
        },
        saveJoinClub() {

            if (!this.currentJoinToClubItem.clubMembershipTypeId) {
                this.$showError("Please select club membership")
                return;
            }

            if (!this.currentJoinToClubItem.clubId) {
                this.$showError("Please select club you want to join")
                return;
            }

            if (!this.currentJoinToClubItem.price || this.currentJoinToClubItem.price < 1 || this.currentJoinToClubItem.price > 1000) {
                this.$showError("Price has not correct value. Use number from 1 to 1000");
                return;
            }

            var self = this;
            var params = {
                id: self.currentJoinToClubItem.id,
                clubId: self.currentJoinToClubItem.clubId,
                price: self.currentJoinToClubItem.price,
                clubMembershipTypeId: self.currentJoinToClubItem.clubMembershipTypeId
            };
            svc.saveClubMembershipTypeForClub(params)
                .then(function (resp) {
                    var allData = resp.body;
                    if (!allData || !allData.isSuccess) {
                        self.$showError(allData.message);
                        self.isNeedChangeYears = true;
                    } else {
                        self.$showSuccess();
                        self.loadConnectedClubs();
                    }
                }, resp => { });
        }
    },
    created() {
        this.queriedData();
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/club/club-membership-type/club-membership-type.js